module.exports = __webpack_public_path__ + "img/plant-trees.42f91ef3.png";